import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';

export enum AuthActionTypes {
  Init = '[Auth] Init',
  Login = '[API] Login',
  LoginSuccess = '[API] Login Success',
  LoginFail = '[API] Login Fail',
  LoginRedirect = '[Auth] Login redirect',
  AdfsRedirect = '[Auth] Adfs redirect',
  Logout = '[Auth] Logout',
  LogoutSuccess = '[] Logout sucess',
  SetToken = '[Auth] Set token',
  DeleteToken = '[Auth] Delete token',
  DeleteTokenSuccess = '[Auth] Delete token success'
}

export class Login implements Action {
  readonly type = AuthActionTypes.Login;
  constructor(public email: string, public password: string) {}
}

export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LoginSuccess;
  constructor(public token: string) {}
}

export class LoginFail implements Action {
  readonly type = AuthActionTypes.LoginFail;
  constructor(public error: HttpErrorResponse) {}
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
  constructor(public typeView?: any) {}
}

export class LogoutSuccess implements Action {
  readonly type = AuthActionTypes.LogoutSuccess;
  constructor(public typeView?: any) {}
}

export class SetToken implements Action {
  readonly type = AuthActionTypes.SetToken;
  constructor(public token: string) {}
}

export class DeleteToken implements Action {
  readonly type = AuthActionTypes.DeleteToken;
  constructor(public typeView?: any) {}
}

export class DeleteTokenSuccess implements Action {
  readonly type = AuthActionTypes.DeleteTokenSuccess ;
  constructor(public typeView?: any) {}
}

export class Init implements Action {
  readonly type = AuthActionTypes.Init;
  constructor() {}
}

export class LoginRedirect implements Action {
  readonly type = AuthActionTypes.LoginRedirect;
  constructor() {}
}

export class AdfsRedirect implements Action {
  readonly type = AuthActionTypes.AdfsRedirect;
  constructor() {}
}

export type AuthActionsUnion =
  | Login
  | LoginSuccess
  | LoginFail
  | LoginRedirect
  | AdfsRedirect
  | SetToken
  | DeleteToken
  | Logout
  | LogoutSuccess
  | DeleteTokenSuccess
  | Init;
